import {getCookie, setCookie} from '../utils/utils'; 

// Form input focus state classes
jQuery(document).ready(function ($) {
  jQuery('.focus_field input[type="text"]').focus(function () {
    $(this).addClass("add-focus");
  });
  jQuery('.focus_field input[type="text"]').blur(function () {
    $(this).removeClass("add-focus");
  });
  jQuery(".focus_field textarea").focus(function () {
    $(this).addClass("add-focus");
  });
  jQuery(".focus_field textarea").blur(function () {
    $(this).removeClass("add-focus");
  });
});


// Show Webinar video
const showWebinarVideo = () => {
  jQuery(".webinar-thumbnail").css("display", "none");

  jQuery(".webinar-video").css("display", "block");
  jQuery(".webinar-video").css("opacity", "1");
  jQuery(".webinar-video").css("transform", "translateY(0)");
}


jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
  const slug = event.currentTarget.location.pathname.replace(/\//g, "");

  if (formId === 6 || formId === 18 || formId === 22 || formId === 23) {
    showWebinarVideo();
    setCookie(slug, JSON.stringify(true), 7300);
  }
});


jQuery(document).ready(function ($) {
  $(".webinar-thumbnail").click(function () {
    $("#input_6_1_3").focus();
  });

  const slug = window.location.pathname.replace(/\//g, "");

  if (getCookie(slug)) {
    jQuery(".contact-form-section").css("display", "none");
    showWebinarVideo();
  }
  $(window).on("load", function (event) {});

  // Redirect from the data sets page if they haven't filled out the form
  if(document.body.classList.contains('page-id-5782')){
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const sc = params.get('submissionGuid');
    if (sc) {
      let date = new Date();
      date.setDate(date.getDate()+30);
      const expires = date.toUTCString();
      document.cookie = 'form_public_data_set=filled; expires=' + expires + '; path=/';
    } else {
      const loggedIn = document.body.classList.contains('logged-in');
      const hasCookie = getCookie('form_public_data_set');

      if(!loggedIn && !hasCookie){
        window.location.href = window.location.origin + '/scalebio-public-data-sets-access-form-page/';
      }
    }
  }

  // Redirect to the data sets page if they have already filled out the form
  if (document.body.classList.contains('page-id-5717')) {
    const loggedIn = document.body.classList.contains('logged-in');
    const hasCookie = getCookie('form_public_data_set');

    if (loggedIn || hasCookie) {
      window.location.href = window.location.origin + '/data-sets-download/';
    }
  }

});

